// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"528":"codemirror","909":"notifications","961":"returns"}[chunkId] + "." + {"528":"dde3c144f64b968161e7","909":"cae30f091d5f4e3ab937","961":"d1c0526c81128da16a4a"}[chunkId] + ".css";
};